import { render } from "./PopupOverlay.vue?vue&type=template&id=367f5ee2&scoped=true"
import script from "./PopupOverlay.vue?vue&type=script&lang=js"
export * from "./PopupOverlay.vue?vue&type=script&lang=js"

import "./PopupOverlay.vue?vue&type=style&index=0&id=367f5ee2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-367f5ee2"]])

export default __exports__